module.exports = __webpack_public_path__ + "static/media/metric_zh.7c31c968.png";